import React from "react";
import {
    Accordion,
    Button,
    Group,
    Paper,
    Stack,
    Text,
    ThemeIcon,
} from "@mantine/core";
import { IconExternalLink, IconFileText } from "@tabler/icons-react";
import type { EventFileDto, EventFileSectionDto } from "../types";
import type { Texts } from "../texts";

type Props = {
    fileSections: EventFileSectionDto[];
    apiUrl?: string;
    t: Texts;
};

export default function FilesSection({ fileSections, apiUrl, t }: Props) {
    return (
        <Accordion.Item value="files">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconFileText size={18} />
                    </ThemeIcon>
                }
            >
                {t.documents}
            </Accordion.Control>

            <Accordion.Panel>
                {fileSections.length === 0 ? (
                    <Text c="dimmed">{t.noDocuments}</Text>
                ) : (
                    <Stack gap="md">
                        {fileSections.map((section) => (
                            <Paper key={section.eventFileSectionID} withBorder p="md" radius="md">
                                <Stack gap="sm">
                                    <div>
                                        <Text fw={700}>{section.name}</Text>

                                        {section.description && (
                                            <Text size="sm" c="dimmed" mt={4}>
                                                {section.description}
                                            </Text>
                                        )}
                                    </div>

                                    <Stack gap="xs" ml="md">
                                        {section.files.map((f: EventFileDto) => {
                                            const href = f.downloadUrl?.startsWith("http")
                                                ? f.downloadUrl
                                                : `${apiUrl}${f.downloadUrl}`;

                                            return (
                                                <Paper
                                                    key={f.fileID}
                                                    withBorder
                                                    p="sm"
                                                    radius="md"
                                                    bg="gray.0"
                                                >
                                                    <Group justify="space-between" wrap="nowrap" align="flex-start">
                                                        <div style={{ minWidth: 0 }}>
                                                            <Text fw={600} lineClamp={2}>
                                                                {f.name}
                                                            </Text>
                                                        </div>

                                                        <Button
                                                            color="red"
                                                            variant="light"
                                                            size="xs"
                                                            rightSection={<IconExternalLink size={16} />}
                                                            component="a"
                                                            href={href}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {t.open}
                                                        </Button>
                                                    </Group>
                                                </Paper>
                                            );
                                        })}
                                    </Stack>
                                </Stack>
                            </Paper>
                        ))}
                    </Stack>
                )}
            </Accordion.Panel>
        </Accordion.Item>
    );
}